import { clone } from './object';

/**
 * Upsert an object into `array` by matching `key`: replace the existing entry
 * whose `key` matches the (cloned) object, otherwise append it. Mutates and
 * returns `array`.
 */
export const upsert = <T extends Record<string, unknown>>(
    obj: T,
    array: T[],
    key: keyof T,
): T[] => {
    const cloned = clone(obj);
    const inx = array.findIndex((item) => item[key] === cloned[key]);
    if (inx >= 0) {
        array[inx] = cloned;
    } else {
        array.push(cloned);
    }
    return array;
};

/**
 * Append `value` to a primitive `array` only when it is not already present.
 * Mutates and returns `array`. Throws when `array` or `value` is missing.
 */
export const insertIfNotExists = <T>(array: T[], value: T): T[] => {
    if (!value || !array) {
        throw new Error(
            'util.array.insertIfNotExists: @array and @value parameters are required.',
        );
    }

    const inx = array.findIndex((item) => item === value);
    if (inx < 0) {
        array.push(value);
    }
    return array;
};
